/** Service Desk console: Mga asset at detalye ng asset (C06/C07, SD-S3-10). */
export const serviceAssets = {
  subtitle: "Ang naka-install na kagamitan sa mga customer mo: serial, saklaw ng warranty, kontrata at maintenance.",
  relative: { today: "ngayon", in_one: "sa loob ng {{count}} araw", in_other: "sa loob ng {{count}} araw", ago_one: "{{count}} araw na ang nakalipas", ago_other: "{{count}} araw na ang nakalipas" },
  orgTab: { viewAll: "Tingnan ang lahat ng asset", emptyTitle: "Wala pang kagamitan", emptyBody: "Lalabas dito ang mga asset kapag tinanggap ng client ang trabaho, kapag nagdagdag ka, o pagkatapos ng import." },
  sections: { label: "Mga seksyon ng Assets", assets: "Mga asset", contracts: "Mga kontrata" },
  actions: {
    create: "Bagong asset",
    import: "I-import ang CSV",
    labels: "I-print ang mga QR label",
    labelOne: "I-print ang QR label",
    edit: "I-edit ang asset",
    move: "Ilipat ang asset",
    archive: "I-archive ang asset",
    restore: "Ibalik",
  },
  stats: {
    label: "Buod",
    assets: "Mga asset",
    assetsHint: "hindi naka-archive",
    covered: "Sakop ng warranty",
    coveredHint: "kasama ang malapit nang mag-expire",
    expiring: "Malapit nang mag-expire",
    expiringHint: "nasa loob ng warranty window",
    overdue: "Lagpas na ang maintenance",
    overdueHint: "kailangan ng bisita",
  },
  overdue: {
    banner_one: "{{count}} asset ang lagpas na ang maintenance:",
    banner_other: "{{count}} asset ang lagpas na ang maintenance:",
    more_one: " at {{count}} pa.",
    more_other: " at {{count}} pa.",
  },
  filters: {
    warrantyGroup: "Filter ng warranty",
    warranty: { all: "Lahat", in_warranty: "May warranty", expiring: "Malapit nang mag-expire", expired: "Expired na", unknown: "Hindi pa nagsisimula o hindi alam" },
    search: "Hanapin ang tag, serial o produkto",
    searchLabel: "Maghanap ng mga asset",
    organisation: "Organisasyon",
    allOrganisations: "Lahat ng organisasyon",
    status: "Status",
    allStatuses: "Lahat ng status",
    category: "Kategorya",
    categoryLabel: "I-filter ayon sa kategorya",
    allCategories: "Lahat ng kategorya",
    clear: "I-clear ang mga filter",
  },
  status: { active: "Aktibo", under_repair: "Ipinaaayos", decommissioned: "Hindi na ginagamit", returned: "Ibinalik" },
  due: { pm: "PM", calibration: "Calibration", overdueBy_one: "lagpas ng {{count}} araw", overdueBy_other: "lagpas ng {{count}} araw" },
  list: {
    label: "Mga asset",
    asset: "Asset",
    organisation: "Organisasyon",
    warranty: "Warranty",
    status: "Status",
    nextDue: "Susunod na due",
    warrantyEnds: "Matatapos sa {{date}}",
    selectAll: "Piliin ang lahat ng asset",
    select: "Piliin ang {{tag}}",
    showing: "Ipinapakita ang {{shown}} sa {{total}} asset",
    loadMore: "Magpakita pa",
  },
  bulk: { label: "Mga bulk na aksyon", selected_one: "{{count}} ang napili", selected_other: "{{count}} ang napili", clear: "I-clear ang pinili" },
  empty: {
    title: "Wala pang asset",
    body: "I-rehistro ang kagamitang na-install o naibenta mo, kasama ang serial at warranty, para alam ng mga ticket at bisita kung ano ang tinutukoy.",
    filteredTitle: "Walang tumutugmang asset",
    filteredBody: "Subukan ang ibang tag o serial, o i-clear ang filter.",
  },
  error: { title: "Hindi ma-load ang mga asset", body: "Tingnan ang koneksyon mo at subukan ulit. Walang nabago." },
  errors: {
    serialTaken: "May ibang asset nang may ganitong serial number.",
    archived: "Naka-archive ang asset na ito. Ibalik muna bago baguhin.",
    siteInUse: "May mga asset pa ang site na ito.",
  },
  form: {
    createTitle: "Bagong asset",
    createDescription: "May ibibigay na tag tulad ng AST-0001 kapag na-save.",
    editTitle: "I-edit ang asset",
    editDescription: "Itinatala sa timeline ng {{tag}} ang mga pagbabago.",
    organisation: "Organisasyon",
    chooseOrganisation: "Pumili ng organisasyon",
    site: "Site",
    noSite: "Walang site",
    noSites: "Wala pang site ang organisasyong ito.",
    name: "Pangalan ng produkto",
    namePlaceholder: "Pangalan ng produkto o kagamitan",
    category: "Kategorya",
    categoryNone: "Walang kategorya",
    manufacturer: "Manufacturer",
    model: "Model",
    serial: "Serial number",
    serialHint: "Natatangi ang serial number sa bawat manufacturer.",
    nickname: "Palayaw",
    location: "Lokasyon sa site",
    purchasedOn: "Petsa ng pagbili",
    installedOn: "Petsa ng pag-install",
    acceptedOn: "Petsa ng pagtanggap",
    status: "Status",
    warranty: "Warranty",
    warrantyHint: "Opsyonal. Kailangan ng petsa ng simula ang warranty na may haba.",
    warrantyStart: "Magsisimula sa",
    warrantyMonths: "Haba (buwan)",
    warrantyBasis: "Nagsisimula sa",
    warrantyProvider: "Ibinibigay ng",
    notes: "Mga tala",
    cancel: "Kanselahin",
    create: "Gumawa ng asset",
    save: "I-save ang mga pagbabago",
    created: "Nagawa ang {{tag}}",
    updated: "Na-update ang asset",
  },
  validation: {
    organisation: "Piliin ang organisasyong pagmamay-ari ng asset na ito.",
    name: "Bigyan ang asset ng pangalang hanggang {{max}} character.",
    serial: "Hanggang {{max}} character ang serial number.",
    text: "Hanggang {{max}} character lang.",
    months: "Maglagay ng buong bilang ng buwan mula 1 hanggang {{max}}.",
    warrantyStart: "Itakda ang petsa ng simula ng warranty.",
  },
  labels: {
    title: "I-print ang mga QR label",
    description_one: "{{count}} label sa {{sheets}} A4 na papel. Binubuksan ng bawat label ang pahina ng asset kapag na-scan.",
    description_other: "{{count}} label sa {{sheets}} A4 na papel. Binubuksan ng bawat label ang pahina ng asset kapag na-scan.",
    startAt: "Magsimula sa label",
    startHint: "Gamitin ang 1 para sa bagong papel; laktawan ng mas mataas na numero ang mga nagamit na (1 hanggang {{max}}).",
    startInvalid: "Maglagay ng numero mula 1 hanggang {{max}}.",
    previewLabel: "Preview ng papel: magsisimula ang print sa label {{start}}, {{count}} sa papel na ito",
    capped: "Unang {{max}} asset lang ang kasya sa isang request.",
    download: "I-download ang PDF",
    done_one: "{{labels}} label sa {{sheets}} papel ang na-save bilang PDF",
    done_other: "{{labels}} label sa {{sheets}} papel ang na-save bilang PDF",
  },
  upload: {
    blocked: "Pinigilan ng security scan ang file na ito.",
    openFailed: "Hindi mabuksan ang file na iyon. Subukan ulit.",
    refused: {
      count: "Masyadong maraming file.",
      type: "Hindi tinatanggap ang uri ng file na ito. Gumamit ng PDF, larawan o text file.",
      size: "Masyadong malaki ang file na ito.",
      empty: "Walang laman ang file na ito.",
    },
  },
  detail: {
    back: "Mga asset",
    loading: "Nilo-load ang asset",
    sections: "Mga seksyon ng asset",
    more: "Iba pang aksyon",
    notFoundTitle: "Hindi nahanap ang asset",
    notFoundBody: "Maaaring na-archive o nailipat na ito. Bumalik sa listahan para hanapin.",
    archivedBanner: "Naka-archive at read-only ang asset na ito. Ibalik ito para mabago.",
    pmOverdue: "Lagpas na ang maintenance",
    serialNo: "SN {{serial}}",
    archiveTitle: "I-archive ang {{tag}}?",
    archiveBody: "Aalis ito sa listahan ng asset at hindi mababago hangga't hindi ibinabalik. Nananatili ang kasaysayan nito.",
    archiveConfirm: "I-archive ang asset",
    archived: "Na-archive ang {{tag}}",
    restored: "Naibalik ang {{tag}}",
  },
  tabs: { overview: "Pangkalahatan", warranty: "Warranty at kontrata", tickets: "Mga ticket", rmas: "Mga return", parts: "Mga piyesa", documents: "Mga dokumento", events: "Mga pangyayari" },
  overview: {
    details: "Mga detalye",
    serial: "Serial",
    model: "Model",
    category: "Kategorya",
    nickname: "Palayaw",
    site: "Site",
    location: "Lokasyon",
    purchased: "Binili",
    installed: "Na-install",
    accepted: "Tinanggap",
    awaitingAcceptance: "Naghihintay ng pagtanggap",
    contract: "Kontrata",
    noContract: "Walang kontratang sumasaklaw sa asset na ito",
    notes: "Mga tala",
    maintenance: "Plano ng maintenance",
    label: "Label ng asset",
    qrLabel: "QR code para sa {{tag}}",
    openTickets: "Mga bukas na ticket",
    noOpenTickets: "Walang bukas na ticket",
  },
  maintenance: {
    label: "Plano ng maintenance",
    task: "Gawain",
    lastDone: "Huling ginawa",
    nextDue: "Susunod na due",
    actions: "Mga aksyon",
    markDone: "Markahang tapos",
    kind: { pm: "Preventive maintenance", calibration: "Calibration" },
    everyMonths_one: "bawat {{count}} buwan",
    everyMonths_other: "bawat {{count}} buwan",
    everyUnits: "bawat {{count}} {{unit}}",
    atMeter: "sa {{value}} {{unit}}",
    emptyTitle: "Walang plano ng maintenance",
    emptyBody: "Magdagdag ng plano ng preventive maintenance o calibration para makakuha ng paalala bago ang due.",
    errorTitle: "Hindi ma-load ang plano ng maintenance",
    errorBody: "Tingnan ang koneksyon mo at subukan ulit.",
    doneTitle: "Markahang tapos ang {{task}}?",
    doneBody: "Ituturing na tapos ngayon ang serbisyo sa {{tag}}, at magsisimula sa ngayon ang susunod na due date.",
    doneConfirm: "Markahang tapos",
    doneSaved: "Namarkahang tapos",
  },
  warranty: {
    title: "Warranty",
    extend: "Palawigin ang warranty",
    status: { in_warranty: "May warranty", expiring: "Malapit nang mag-expire", expired: "Expired na", unknown: "Hindi alam" },
    chip: {
      inWarranty: "May warranty hanggang {{date}}",
      expiring_one: "Mag-e-expire sa loob ng {{count}} araw",
      expiring_other: "Mag-e-expire sa loob ng {{count}} araw",
      expiringToday: "Mag-e-expire ngayon",
      expired: "Nag-expire noong {{date}}",
      notStarted: "Magsisimula sa {{date}}",
      unknown: "Walang warranty na naitala",
    },
    basis: { acceptance: "Pagtanggap", installation: "Pag-install", delivery: "Paghahatid", manual: "Itinakda nang mano-mano" },
    cover: { parts: "Mga piyesa", labor: "Trabaho", travel: "Biyahe" },
    covered: "Sakop",
    notCovered: "Hindi sakop",
    expiredNote: "Expired na ang warranty. May bayad ang pagkumpuni ng asset na ito maliban kung sakop ng kontrata.",
    elapsedLabel: "Nagamit na bahagi ng warranty",
    elapsed: "{{percent}} porsiyento ng panahon ng warranty ang lumipas",
    period: "Mula {{start}} hanggang {{end}}",
    noDates: "Walang nakatakdang petsa ng warranty. Gamitin ang Palawigin ang warranty para magdagdag.",
    starts: "Nagsisimula",
    atAcceptance: "Sa pagtanggap",
    ends: "Nagtatapos",
    provider: "Ibinibigay ng",
    covers: "Sumasaklaw sa",
    terms: "Pinagmulan ng mga tuntunin",
    termsLinked: "May knowledge source na may hawak ng mga tuntunin",
    termsNone: "Walang naka-link na pinagmulan ng mga tuntunin. Sasabihin ng assistant na kukumpirmahin ng team kung ano ang sakop.",
    coverageTitle: "Saklaw",
    item: "Aytem",
    contract: "Kontrata",
    coverageNote: "Laging mula sa pinagmulan ng mga tuntunin ang sinasabi ng assistant sa client tungkol sa saklaw, hindi hula.",
    contractTitle: "Kontrata at SLA",
    openContract: "Buksan ang kontrata",
    contractError: "Hindi ma-load ang kontrata.",
    noContractTitle: "Walang kontrata",
    noContractBody: "Gumagamit ng default na SLA ng workspace ang mga ticket para sa asset na ito.",
    sla: "SLA {{name}}",
    defaultSla: "Default na SLA ng workspace",
  },
  warrantyDialog: {
    title: "Warranty",
    description: "Papalitan nito ang buong tala ng warranty ng {{tag}}. Mapupunta sa timeline ang dahilan.",
    startOn: "Magsisimula sa",
    endOn: "Magtatapos sa",
    months: "o haba sa buwan",
    monthsHint: "Binibilang mula sa petsa ng simula. Iwanang walang laman kung maglalagay ng petsa ng pagtatapos.",
    basis: "Nagsisimula sa",
    provider: "Ibinibigay ng",
    covers: "Sumasaklaw sa",
    reason: "Dahilan",
    reasonHint: "Opsyonal. Halimbawa, kabutihang-loob matapos ang paulit-ulit na pagkasira.",
    save: "I-save ang warranty",
    saved: "Na-save ang warranty",
    problems: {
      end: "Maglagay ng petsa ng pagtatapos o haba sa buwan.",
      bothEndAndMonths: "Maglagay ng petsa ng pagtatapos o haba sa buwan, hindi pareho.",
      order: "Hindi puwedeng matapos ang warranty bago magsimula.",
      months: "Maglagay ng buong bilang ng buwan mula 1 hanggang 240.",
      monthsNeedStart: "Kailangan ng petsa ng simula ang haba sa buwan.",
    },
  },
  moveDialog: {
    title: "Ilipat ang asset",
    description: "Piliin kung nasaan na ang {{tag}}. Nire-record ito sa audit.",
    organisation: "Organisasyon",
    site: "Site",
    confirm: "Kinukumpirma kong binabago ng paglilipat ng asset sa ibang organisasyon kung sino ang makakakita nito.",
    reason: "Dahilan",
    save: "Ilipat ang asset",
    moved: "Nailipat ang {{tag}}",
    problems: { nothing: "Pumili ng ibang site o organisasyon.", confirm: "I-tick ang kahon para kumpirmahin ang paglilipat sa ibang organisasyon." },
  },
  tickets: {
    title: "Mga ticket para sa asset na ito",
    ticket: "Ticket",
    titleCol: "Pamagat",
    status: "Status",
    created: "Ginawa",
    emptyTitle: "Walang ticket para sa asset na ito",
    emptyBody: "Lalabas dito ang mga ticket na ginawa para sa asset na ito.",
    errorTitle: "Hindi ma-load ang mga ticket",
    errorBody: "Tingnan ang koneksyon mo at subukan ulit.",
  },
  parts: {
    title: "Mga piyesang pinalitan",
    record: "I-record ang piyesa",
    date: "Petsa",
    part: "Piyesa",
    coverageCol: "Sakop ng",
    coverage: { warranty: "Warranty", contract: "Kontrata", chargeable: "May bayad" },
    removed: "Serial na inalis",
    new: "Bagong serial",
    emptyTitle: "Wala pang pinalitang piyesa",
    emptyBody: "Lalabas dito, kasama ang serial number, ang mga piyesang naitala sa bisita o dito.",
    errorTitle: "Hindi ma-load ang mga piyesa",
    errorBody: "Tingnan ang koneksyon mo at subukan ulit.",
  },
  partDialog: {
    title: "Mag-record ng piyesa",
    description: "Mapupunta rin ito sa timeline ng asset.",
    partDescription: "Piyesa",
    quantity: "Dami",
    sku: "SKU",
    coverage: "Sakop ng",
    removedSerial: "Serial na inalis",
    newSerial: "Serial na ikinabit",
    save: "I-record ang piyesa",
    saved: "Naitala ang piyesa",
    problems: { description: "Ilarawan ang piyesa sa hanggang {{max}} character.", quantity: "Maglagay ng buong bilang mula 1 hanggang {{max}}." },
  },
  documents: {
    title: "Mga dokumento",
    add: "Magdagdag ng dokumento",
    addTitle: "Magdagdag ng dokumento",
    addDescription: "Sinusuri at ini-scan ang mga file bago ito mabuksan ng sinuman.",
    file: "File",
    fileHint: "PDF, larawan o text file.",
    titleLabel: "Pamagat",
    kind: "Uri",
    kinds: { manual: "Manual", warranty_card: "Warranty card", certificate: "Sertipiko", report: "Ulat", photo: "Larawan", other: "Iba pa" },
    validUntil: "Balido hanggang",
    clientVisible: "Nakikita ng client sa portal",
    clientVisibleHint: "Iwanang naka-off para sa staff lang.",
    upload: "I-upload",
    added: "Naidagdag ang dokumento",
    document: "Dokumento",
    client: "Portal ng client",
    visible: "Nakikita",
    staffOnly: "Staff lang",
    visibleLabel: "Nakikita ng client: {{title}}",
    nowVisible: "Makikita na ng client ang dokumentong ito",
    nowStaffOnly: "Para sa staff lang ang dokumentong ito",
    actions: "Mga aksyon",
    open: "Buksan ang {{title}}",
    remove: "Alisin ang {{title}}",
    removeTitle: "Alisin ang {{title}}?",
    removeBody: "Aalis ang dokumento sa asset. Buburahin ang file.",
    removeConfirm: "Alisin ang dokumento",
    removed: "Naalis ang dokumento",
    validTo: "balido hanggang {{date}}",
    emptyTitle: "Wala pang dokumento",
    emptyBody: "Magdagdag ng manual, warranty card o sertipiko at piliin kung puwede itong makita ng client.",
    errorTitle: "Hindi ma-load ang mga dokumento",
    errorBody: "Tingnan ang koneksyon mo at subukan ulit.",
    problems: { file: "Pumili ng file na i-a-upload.", title: "Bigyan ng pamagat ang dokumento." },
  },
  events: {
    title: "Mga pangyayari",
    filter: "Filter ng pangyayari",
    groups: { all: "Lahat", tickets: "Mga ticket", visits: "Mga bisita", parts: "Mga piyesa", warranty: "Warranty", other: "Iba pa" },
    kind: {
      installed: "Na-install",
      accepted: "Tinanggap ng client",
      ticket_opened: "Binuksan ang ticket",
      ticket_resolved: "Nalutas ang ticket",
      visit: "Bisita",
      part_replaced: "Pinalitan ang piyesa",
      calibration_done: "Tapos ang calibration",
      pm_done: "Tapos ang maintenance",
      moved_site: "Inilipat sa ibang site",
      warranty_extended: "Pinalawig ang warranty",
      status_changed: "Nagbago ang status",
      created: "Na-rehistro ang asset",
      updated: "Na-update ang mga detalye",
      moved_organisation: "Inilipat sa ibang organisasyon",
      archived: "Na-archive",
      restored: "Naibalik",
      document_added: "Naidagdag ang dokumento",
    },
    actor: { staff: "Staff", contact: "Client", system: "Sistema", connector: "Connector", import: "Import" },
    emptyTitle: "Wala pang pangyayari",
    emptyBody: "Dito itinatala ang lahat ng nangyayari sa asset na ito.",
    emptyFilteredTitle: "Walang pangyayari para sa filter na ito",
    emptyFilteredBody: "Piliin ang Lahat para makita ang buong timeline.",
    errorTitle: "Hindi ma-load ang mga pangyayari",
    errorBody: "Tingnan ang koneksyon mo at subukan ulit.",
  },
} as const;
